<template>
  <modal
    v-if="visible"
    :visible="visible"
    @click-outside-modal="emit('close')"
  >
    <div
      class="relative mx-2 flex max-w-[400px] flex-col justify-center gap-3 rounded-lg bg-white p-4"
    >
      <svg
        class="absolute right-3 top-3 cursor-pointer"
        @click="emit('close')"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M18.364 7.05044L16.9498 5.63623L12 10.586L7.05026 5.63623L5.63605 7.05044L10.5858 12.0002L5.63605 16.9499L7.05026 18.3642L12 13.4144L16.9498 18.3642L18.364 16.9499L13.4142 12.0002L18.364 7.05044Z"
          fill="#6C7C9D"
        />
      </svg>

      <img
        class="h-8"
        src="@/assets/alert-square-red.svg"
        alt="alert icon"
      />

      <p class="text-lg font-semibold text-neutral-subtle">
        This vehicle hasn't reported an ELD connection in a long time
      </p>

      <p class="text-sm font-normal text-neutral-subtle">
        This is not one of the ELD connected and active vehicles. Please go to
        Carriers/equipment to update your ELD connection with this vehicle.
      </p>

      <button-main
        class="my-2 text-1md font-semibold !text-neutral-subtle-bold"
        @click="handleConnectEld"
      >
        Connect ELD
      </button-main>
    </div>
  </modal>
</template>

<script setup>
import { defineProps } from 'vue';
import Modal from '@/components/modals/Modal.vue';
import ButtonMain from '@/components/Button.vue';

defineProps({
  visible: Boolean,
  loading: Boolean,
});

const emit = defineEmits(['close', 'success']);

const handleConnectEld = () => {
  console.log('CONNECT');
};
</script>
